import heroFigures from "@/assets/restore/results-hero-figures.png.asset.json";

export function HeroResults() {
  return (
    <section className="relative" style={{ backgroundColor: "#FBFBFB" }}>
    <div className="mx-auto flex max-w-7xl flex-col md:grid md:grid-cols-2 md:items-start md:gap-0">
        {/* Text column */}
        <div className="order-1 relative z-10 px-4 pt-10 pb-4 text-center md:px-12 md:py-16 md:text-left lg:px-16">
          <h1 className="text-sm font-bold tracking-[0.2em] text-black uppercase">
            HAIR TRANSPLANT RESULTS
          </h1>
          <h2 className="mt-2 md:mt-4 text-[36px] leading-[41px] font-normal text-black md:text-[45px] md:leading-[45px]">
            <span className="md:font-bold">The Pros</span> Can Go Anywhere...
          </h2>
          <h2 className="mt-2 text-[36px] leading-[41px] font-normal text-black md:text-[45px] md:leading-[63px]">
            <span className="md:font-bold">They Come</span> to{" "}
            <span className="font-bold text-primary md:text-black md:font-normal">
              RESTORE<sup>®</sup>!
            </span>
          </h2>
          <p className="hidden md:block mt-6 text-base leading-relaxed text-muted-foreground md:text-lg">
            When it comes to hair restoration, the team you choose makes all the difference. Men who
            can go anywhere in the world — NFL legends, TV personalities, world-class performers —
            don&rsquo;t gamble on results. They choose RESTORE because they&rsquo;ve seen what we
            deliver. More than 20,000 men from all walks of life have achieved remarkable hair
            transplant results thanks to RESTORE.
          </p>
        </div>
        {/* Image column. The file is 588x399: shown at most at that size so it is
            not stretched, with the text column's padding so it no longer runs into
            the header and the page edge (Laura's review, 19 Oct 2026). */}
        <div className="order-2 relative flex items-start justify-center px-4 md:justify-end md:px-12 md:py-16 lg:px-16">
          <img
            src={heroFigures.url}
            alt="Deion Sanders and Brian Urlacher, RESTORE hair transplant clients"
            width={588}
            height={399}
            decoding="async"
            loading="eager"
            className="w-full max-w-[588px] h-auto"
          />
        </div>
        {/* Mobile-only headline below image */}
        <h2 className="order-3 md:hidden text-center text-[30px] leading-[36px] font-bold text-black px-4 pt-6 pb-8">
          <span className="font-normal">24 Years of </span>Hair Transplant Success
        </h2>
      </div>
    </section>
  );
}
